import * as React from 'react'
import { makeUserManager } from 'react-oidc';
import config from '../Config/userManagerConfig';
const userManager = makeUserManager(config);

userManager.events.addAccessTokenExpired(function(){
    userManager.signinSilent();
});

export default userManager;